import { type Extrusion, faceNew } from "geom/brep";
import { DIST_EPSILON } from "geom/core";
import { extrudeFace } from "geom/extrude";
import { planeNewXY } from "geom/plane";
import type { PolyLine2 } from "geom/polyLine2Types";

export function makeSolidFloorPlate({
  floorPlatePerimetersWithHoles,
  floorPlateElevation,
  plateThickness,
}: {
  floorPlatePerimetersWithHoles: PolyLine2[][];
  floorPlateElevation: number;
  plateThickness: number;
}): Extrusion[] {
  const solidFloorPlate: Extrusion[] = [];

  if (plateThickness < DIST_EPSILON) {
    return solidFloorPlate;
  }

  const floorPlane = planeNewXY(0, 0, floorPlateElevation);

  for (const floorPlatePerimeter of floorPlatePerimetersWithHoles) {
    const subFloorFace = faceNew([floorPlatePerimeter[0], ...floorPlatePerimeter.slice(1)], floorPlane);
    const extrudedFace = extrudeFace(subFloorFace, 0, 0, -plateThickness);
    solidFloorPlate.push(extrudedFace);
  }

  return solidFloorPlate;
}
